<ng-container *ngIf="category.companiesCnt > 3; else defaultList">
  <button type="button" class="overflow-hidden more-companies" [ngClass]="{ btn: viewType === 'list' }" [matMenuTriggerFor]="singleList">
    <span class="companies-list" [ngClass]="{ ellipsis: viewType === 'list' }"> {{ companiesNamesTruncated }}</span>
    <span class="ml-4">and {{ category.companiesCnt - 3 }} more</span>
    <span class="gray ml-4" *ngIf="viewType === 'details'"
      >added {{ category.ideasCnt | i18nPlural: ideasMapping | craftTerm: { count: category.ideasCnt } }}</span
    >
  </button>
  <mat-menu #singleList="matMenu">
    <ng-template matMenuContent="">
      <span mat-menu-item="" (click)="$event.stopPropagation()" *ngFor="let item of companies$ | async | slice: 0:100; trackBy: identify">{{ item.name }}</span>
    </ng-template>
  </mat-menu>
</ng-container>

<ng-template #defaultList>
  <span class="companies-list" [ngClass]="{ ellipsis: viewType === 'list' }">
    <span [matTooltip]="companiesNamesTruncated" matTooltipPosition="above">
      {{ companiesNamesTruncated }}
    </span>
    <span class="gray ml-4" *ngIf="viewType === 'details'"
      >added {{ category.ideasCnt | i18nPlural: ideasMapping | craftTerm: { count: category.ideasCnt } }}</span
    >
  </span>
</ng-template>
